import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
import { map } from "rxjs/operators";
import { environment } from "../../environments/environment";
import { AutomapperService } from "../core/automapper/automapper.service";
// import { GainSightPxService } from "../core/meta/gainsightPx.service";
import { LocalService } from "../core/storage/local.service";
import { SessionService } from "../core/storage/session.service";
import { UserToken } from "./user-token.model";
import * as i0 from "@angular/core";
import * as i1 from "../core/environment.tokens";
import * as i2 from "@angular/router";
import * as i3 from "../core/automapper/automapper.service";
import * as i4 from "@angular/common/http";
import * as i5 from "../core/storage/session.service";
import * as i6 from "../core/storage/local.service";
// TODO: Put in a service before using somewhere else.
// TODO: This doesn't work? Testing for now...
if (environment.production) {
    window.newrelic = window.newrelic || {};
}
export class AuthService {
    constructor(baseApiUrl, router, automapper, http, session, local
    // private readonly gainSightPxService: GainSightPxService
    ) {
        this.baseApiUrl = baseApiUrl;
        this.router = router;
        this.automapper = automapper;
        this.http = http;
        this.session = session;
        this.local = local;
        this.AUTHENTICATION_KEY = "authentication";
        this.tempAuthKey = "temp_auth";
        this.redirectUrl = "";
        this.loginSuccess = (user) => {
            if (user.isMFAEnabled) {
                this.setTemporaryTokenForMfa(user);
                this.router.navigateByUrl("login/mfa");
            }
            else {
                this.loginVerified(user);
            }
        };
        this.logoutComplete = () => {
            this.session.clear();
            this.local.clear();
            // NOTE: When users logout we refresh to possibly get newly deployed code.
            this.local.put("refresh", true);
            this.router.navigate(["login"]);
        };
    }
    get user() {
        const user = this.session.get(this.AUTHENTICATION_KEY, {});
        return new UserToken(user);
    }
    get isAuthenticated() {
        return this.user.isAuthenticated;
    }
    get username() {
        return this.user.username;
    }
    get userId() {
        return this.user.userId;
    }
    login(username, password) {
        this.sendLoginRequest(username, password).subscribe(this.loginSuccess);
    }
    logout() {
        this.sendLogoutRequest(this.username).subscribe();
        this.logoutComplete();
    }
    sendLoginRequest(username, password) {
        const url = `${this.baseApiUrl}authentication/login`;
        return this.http
            .post(url, { userName: username, password })
            .pipe(map(this.automapper.curry("default", "UserToken")));
    }
    setUserToken(value) {
        this.session.put(this.AUTHENTICATION_KEY, value);
    }
    setTemporaryTokenForMfa(value) {
        this.session.put(this.tempAuthKey, value);
    }
    get tempUserTokenForMfa() {
        const user = this.session.get(this.tempAuthKey, {});
        return new UserToken(user);
    }
    removeTempUserTokenForMfa() {
        this.session.delete(this.tempAuthKey);
    }
    sendLogoutRequest(username) {
        const url = `${this.baseApiUrl}authentication/logout`;
        return this.http.post(url, { userName: username });
    }
    getMicroserviceUrl() {
        const url = `${this.baseApiUrl}authentication/identitymicroserviceurl`;
        return this.http.get(url).pipe(map((response) => response));
    }
    loginVerified(user) {
        this.setUserToken(user);
        // this.redirectUrl = StringHelper.isAvailable(user.userOnboardingUrl) ? user.userOnboardingUrl : user.homePageUrl;
        this.redirectUrl = user.homePageUrl;
        // TODO: Put in a service before using somewhere else.
        // TODO: This doesn't work? Testing for now...
        if (environment.production) {
            window.newrelic.setCustomAttribute("mrcsUserId", user.userId);
            window.newrelic.setCustomAttribute("mrcsOrgId", user.organizationId);
        }
        // this.gainSightPxService.initialize(user);
        // if (user.isTemporaryPassword) {
        //   this.redirectUrl = "/onboarding";
        // }
        this.router.navigateByUrl(this.redirectUrl);
    }
    get userOrganizationName() {
        return this.user.organizationName;
    }
    get userFirstName() {
        return this.user.firstName;
    }
    get userLastName() {
        return this.user.lastName;
    }
}
AuthService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthService_Factory() { return new AuthService(i0.ɵɵinject(i1.BASE_API_URL), i0.ɵɵinject(i2.Router), i0.ɵɵinject(i3.AutomapperService), i0.ɵɵinject(i4.HttpClient), i0.ɵɵinject(i5.SessionService), i0.ɵɵinject(i6.LocalService)); }, token: AuthService, providedIn: "root" });
